import { type ReactNode } from 'react'
import { Route, Routes } from 'react-router'
import { PageNotFound } from 'pages/pageNotFound/ui/pageNotFound'

type IRoutesWithNotFoundProps = {
  children: ReactNode
}

export const RoutesWithNotFound = ({ children }: IRoutesWithNotFoundProps) => (
  <Routes>
    {children}
    <Route path='*' element={<PageNotFound />} />
  </Routes>
)
